// extracted by mini-css-extract-plugin
export default {"heroSection":"home_heroSection__B5IQx","heroText":"home_heroText__VFtej","infoSection":"home_infoSection__Q49wQ","contentSection":"home_contentSection__SpNtc"};